import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/image/subpage/why-content2.png';
var _withScopeId = function (n) {
  return _pushScopeId("data-v-b6bf57d2"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "wrap"
};
var _hoisted_2 = {
  class: "inner text-center"
};
var _hoisted_3 = /*#__PURE__*/_createTextVNode("旨在孩子九大能力的培养");
var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("img", {
    class: "power-img",
    src: _imports_0,
    alt: "",
    srcset: ""
  }, null, -1);
});
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_ModuleTitle = _resolveComponent("ModuleTitle");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_ModuleTitle, {
    class: "module-title"
  }, {
    default: _withCtx(function () {
      return [_hoisted_3];
    }),
    _: 1
  }), _hoisted_4])]);
}